import React from 'react';
import '../../../css/Form.css';
import Select from 'react-select';
import UploadFile from '../../../helper/UploadFile';

const EligibilityTest = (props) => {
	const {
		Eligibility,
		EducationalDetailsDropDownHandler,
		YearsDropDownData,
		addComponent,
		GenerateRemovePopup,
		EligibilityTests,
		// onFileChange,
		// imageRemoveHandler,
		// openImageInTab,
		userDetails,
		setUserDetails,
		UploadData,
		setSaveTheData
	} = props;

		//UPLOAD COMPONENT DATA SETTING
	const uploadProcessCode = "EMPLOYEE_APP_EDN_ELIGIBILITY_TEST";
	const processCodeData= UploadData.filter((item)=>item.uploadProcessCode===uploadProcessCode)


	// const [openView, setOpenView] = useState({
	// 	popupOpen: false,
	// 	currentIndex: null
	// });

	// const popupHandler = (event) => {
	// 	var oldObj = { ...openView };
	// 	oldObj.popupOpen = true;
	// 	oldObj.currentIndex = event.target.id;
	// 	setOpenView(oldObj);
	// };

	// const ClosePopup = () => {
	// 	var oldObj = { ...openView };
	// 	oldObj.popupOpen = false;
	// 	setOpenView(oldObj);
	// };

	const getUploadData = (data, index) => {
		let newState = { ...userDetails };
		newState.EligibilityTest[index].Documents = data
		setUserDetails(newState);
		setSaveTheData(true)
	};

	return (
		<div className="col-12">
			{Eligibility.map((el, index) => {
				return (
					<div key={index} className="animated zoomIn container-fluid">
						<div className="row p-1">
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Eligibility Test
								</label>
								<Select
									className="z-depth-3"
									value={el.EligibilityTestName}
									onChange={(selected) =>
										EducationalDetailsDropDownHandler(
											selected,
											index,
											'EligibilityTestName',
											'EligibilityTest'
										)}
									options={EligibilityTests}
									isClearable
								/>
							</div>
							<div className="col-md-3">
								<label className="formRenderlabel ">
									Year of Completion
								</label>
								<Select
									className="z-depth-3"
									value={el.EligibilityYearOfComp}
									onChange={(selected) =>
										EducationalDetailsDropDownHandler(
											selected,
											index,
											'EligibilityYearOfComp',
											'EligibilityTest'
										)}
									options={YearsDropDownData}
									isClearable
								/>
							</div>
							<div className="col-md-4">
								<label className="formRenderlabel ">
									Document 
									<span className='upload-accepted-format-indication'>({processCodeData[0]?.fileTypeList.join(',')})</span>
								</label>
								<UploadFile
									callback={getUploadData}
									data={el?.Documents}
									isMulti
							keyList={processCodeData}
									id={uploadProcessCode}
									otherParams={index}
								/>
								<br/>
												<span className='upload-accepted-format-indication'>File size limit: less than 1024kb</span>
								{/* <label className="educationUpload">
									<input
										type="file"
										style={{ display: 'none' }}
										onChange={(event) => onFileChange(event, 'EligibilityTest')}
										accept="image/*"
										id={index}
										multiple
									/>
									[ <i className="fa fa-upload uploadIcon" aria-hidden="true"></i> Upload ]
								</label>
								<label className="educationUpload">
									<input
										type="button"
										style={{ display: 'none' }}
										onClick={popupHandler}
										id={index}
									/>
									[ <i className="fa fa-eye uploadIcon" aria-hidden="true"></i> view ]
								</label> */}
							</div>
							{
								index >= 1 ? (
									<div className="col-md-2">
										<button
											type="button"
											className="EligibilityRemoveButton pull-right"
											onClick={() =>
												GenerateRemovePopup('EducationPopup', index, 'Education', 'Eligibility')}
											id={index}
											title="Eligibility"
										>
											<i className="fa fa-trash RemoveIcon" />
											Remove
										</button>
									</div>
								) : null
							}
						</div >
					</div >
				);
			})}
			<div className="">
				<div className='row p-1'>
					<div className="col-md-12 d-flex justify-content-end">
						<button
							type="button"
							className="formLinkButton "
							title="Eligibility"
							onClick={() => addComponent('Education', 'Eligibility')}
						>
							<span className="fa fa-plus formAddIcon" />Add More (Eligibility Test)
						</button>
					</div>
				</div>
			</div>
			<div className="appDivider" />
			{/* {
				openView.popupOpen ? (
					<ImagesPopup
						open={openView.popupOpen}
						close={ClosePopup}
						Imgdata={Eligibility}
						imageRemoveHandler={imageRemoveHandler}
						currentIndex={openView.currentIndex}
						compName="EligibilityTest"
						openImageInTab={openImageInTab}
						isFromEducation={false}
					/>
				) : null
			} */}
		</div >
	);
};

export default EligibilityTest;
